import _ from 'lodash'
import { flow, get, find, isEmpty, negate, map, filter } from 'lodash/fp'
import { createSelector } from 'reselect'

import values from 'core/data-model/constants/values'

export const getiCareSelectedPlanCode = (state) => _.get(state, 'coveragePlan.riders["ESCI"].selectedPlan.planCode')

export const getAllBasicPlanOptions = (state) => _.get(state, 'coveragePlan.riders["ESCI"].options.0.values')

export const getESCIRider = (state) => get('coveragePlan.riders["ESCI"]')(state)

export const getDiscountStatus = createSelector(getiCareSelectedPlanCode, getESCIRider, (planCode, rider) => {
  return flow(
    get('options.0.values'),
    find({ planCode: planCode, group: values.RIDER_OPTION_GROUP_DISCOUNT }),
    negate(isEmpty)
  )(rider)
})

export const getSelectedRiderPlan = createSelector(
  getiCareSelectedPlanCode,
  getAllBasicPlanOptions,
  (planCode, options) => _.find(options, { planCode })
)

export const getBasicPlanOptions = createSelector(
  (appState) => getDiscountStatus(appState),
  getESCIRider,
  (isDiscount, rider) => {
    return flow(
      get('options.0.values'),
      filter(['group', isDiscount ? values.RIDER_OPTION_GROUP_DISCOUNT : values.RIDER_OPTION_GROUP_NO_DISCOUNT]),
      map((p) => ({
        value: p.planCode,
        text: `แผน ${p.text}`,
      }))
    )(rider)
  }
)

export const getSameValuePlanCode = createSelector(
  getAllBasicPlanOptions,
  getiCareSelectedPlanCode,
  getDiscountStatus,
  getSelectedRiderPlan,
  (options, planCode, isDiscountBeforeToggle, selectedOption) =>
    flow(
      find({
        group: isDiscountBeforeToggle ? values.RIDER_OPTION_GROUP_NO_DISCOUNT : values.RIDER_OPTION_GROUP_DISCOUNT,
        value: selectedOption.value,
      }),
      get('planCode')
    )(options)
)

export const getICareSelectedPlanName = (state) => _.get(state, 'coveragePlan.riders["ESCI"].selectedPlan.plan', '')
export const getICareSelectedPlanCode = (state) => _.get(state, 'coveragePlan.riders["ESCI"].selectedPlan.planCode', '')
